import React from 'react'
import Head from 'next/head'
import { Box, Button, Container, CssBaseline, Typography } from '@mui/material'

const ServiceStoppedPage = () => (
  <>
    <Head>
      <title>サービス終了のお知らせ | ハピログフォトブック</title>
      <meta
        name="description"
        content="ハピログフォトブックは2026年6月4日をもちましてサービスを終了しました。"
      />
    </Head>
    <CssBaseline />
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f7f8f5',
        color: '#263238',
        py: { xs: 4, sm: 7 },
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minHeight: { md: 'calc(100vh - 112px)' },
          }}
        >
          <Typography
            component="h1"
            sx={{
              fontSize: { xs: 30, sm: 38, md: 44 },
              fontWeight: 700,
              lineHeight: 1.25,
              mb: 3,
            }}
          >
            ハピログフォトブックはサービスを終了しました
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 18 },
              lineHeight: 1.9,
              mb: 3,
            }}
          >
            ハピログフォトブックは2026年6月4日をもちましてサービスを終了いたしました。
            長らくご利用いただき、誠にありがとうございました。
          </Typography>
          <Typography sx={{ lineHeight: 1.8, mb: 4 }}>
            ご注文済み商品の配送やサービス終了に関するご案内は、以下のお知らせをご確認ください。
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
            }}
          >
            <Button
              component="a"
              href="https://happylogue.com/blog/cmpkmpa8j3qup0715f1l7d4f4"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              color="primary"
            >
              サービス終了のお知らせ
            </Button>
            <Button
              component="a"
              href="https://happylogue.com/contact/"
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              color="inherit"
            >
              お問い合わせ
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  </>
)

export default ServiceStoppedPage
